import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { logger } from 'logger'

import applicationAPI from 'remote/applications'
import {
  createErrorToasterMessage,
  createSuccessToasterMessage,
} from 'data/ui/actions'

import { makesMutations } from 'data/graphql'

const providesShareToApplication = compose(
  connect(
    null,
    { createErrorToasterMessage, createSuccessToasterMessage }
  ),
  makesMutations({
    query: applicationAPI.shareToApplication,
    mutationPropName: 'shareToApplication',
    getOnResultFromProps: ({ createSuccessToasterMessage, integration }) => ({
      result,
    }) => {
      const {
        shareToSuccess,
        shareToSuccessLinkLabel,
      } = integration.application.labels
      const { url } = result.data.shareToApplication
      createSuccessToasterMessage({
        title: shareToSuccess,
        id: 'note-share-success',
        renderAction: url
          ? () => (
              <a
                className="inline-block primary margin-top-small"
                href={url}
                target="_blank"
                rel="noopener noreferrer"
              >
                {shareToSuccessLinkLabel}
              </a>
            )
          : null,
      })
      return result
    },
    getOnErrorFromProps: ({ createErrorToasterMessage }) => result => {
      logger.error('Error while sharing doc', result)
      createErrorToasterMessage({
        title: 'Error while sharing the doc',
        id: 'note-share-error',
      })
    },
  })
)

export default providesShareToApplication
